import { Toggle } from '@ps/web-shared-components';
import type { ChangeEvent } from 'react';
import React from 'react';
import { Form } from 'react-final-form';
import { useIntl } from 'react-intl';

import { usePokerMultiTableTournamentsWidget } from '../../../../model';

import { TXTCLI_Show_Upcoming_Only } from './UpcomingToggle.messages.json';
import styles from './UpcomingToggle.scss';

const UpcomingToggle: React.FC = () => {
  const { widgetDispatch } = usePokerMultiTableTournamentsWidget();
  const { formatMessage } = useIntl();

  const handleOnToggleChanged = ({ target: { checked } }: ChangeEvent<HTMLInputElement>) => {
    const upcomingOnly = checked;
    widgetDispatch.setActiveFilters({ upcomingOnly });
    widgetDispatch.subscribeToTournaments({ setLoading: true });
  };

  return (
    <Form
      onSubmit={() => undefined}
      initialValues={{ upcomingToggle: true }}
      render={() => (
        <div className={styles.toggle}>
          <Toggle
            label={formatMessage(TXTCLI_Show_Upcoming_Only)}
            id="upcomingToggle"
            type="checkbox"
            onChange={handleOnToggleChanged}
            className={styles.label}
          />
        </div>
      )}
    />
  );
};

export default UpcomingToggle;
